import * as types from './action-types';

const defaultState = {
    hasError: false,
    error: null,
    offer: {},
    selecting: false,
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.OFFER_SELECTING_FAILURE:
        return Object.assign({}, state, {
            error: action.error,
            hasError: true,
            selecting: false,
        });

    case types.OFFER_SELECTING_PENDING:
        return Object.assign({}, state, {
            error: null,
            hasError: false,
            selecting: true,
        });

    case types.OFFER_SELECTING_SUCCESS:
        return Object.assign({}, state, {
            error: null,
            hasError: false,
            offer: action.res.data.offer,
            // fix loading bug: keep true to maintain loading state until navigation completes
            // The component will unmount during navigation, so this won't cause issues
            selecting: true,
        });

    default:
        return Object.assign({}, state);
    }
};

export default reducer;
